<template>
    <v-container>
        <v-row justify="center">
            <v-col align="center">
                <div class="not-found">
                    <h1>404</h1>
                    <div class="not-fount-content">
                        <h2> Oops! Page Not Found. </h2>
                        <p> The page you are requesting could not be found. Please go back to home page or use our navigation menu.  </p>
                        <v-btn
                        rounded
                        height="60"
                        width="250"
                        elevation="10"
                        color="primary"
                        class="btn"
                        to="/"
                        >Go to homePage
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        name: "404Page",
        
    }
</script>

<style scoped>
.not-found {
    font-family: Avenir3;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.not-found h1 {
    font-size: 350px;
    letter-spacing: 20px;
    opacity: 0.1;
    position: absolute;
}
.not-found h2 {
    font-size: 36px;
}

@media screen and (max-width: 650px){
    .not-found h1 {
        font-size: 150px;
    }
}

</style>